import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import DynamicFilterElement from './DynamicFilterElement';

const styles = theme => ({
  paper: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    marginTop: 10,
    marginBottom: 20,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  boxShadow: {
    border: `1px solid ${theme.palette.background.default}`,
    boxShadow: `0 1px 1px rgba(0,0,0,0.14)`
  }
});

class DynamicFilters extends PureComponent {

  constructor(props) {
    super(props);
    this.state = { flag: this.filterSegment(this.props) };
  }

  filterSegment(props) {
    const { groupName } = props;
    let months;
    let flag = false;
    for (let i = 0; i < this.props.elements.length; i++) {
      if (this.props.elements[i].label == "Month") {
        months = this.props.elements[i].options;
        break;
      }
    }
    flag = months.some(data => data.value >= 280);

    if (["ford-us", "ford-lincoln"].includes(groupName) && flag) {
      return true;
    }
    else {
      return false;
    }

  }



  update = (index, v, groupName) => {
    const { update } = this.props;
    const selections = this.props.selections.map((selection, idx) => {
      return idx < index
        ? selection
        : idx === index
          ? { field: selection.field, value: v }
          : { field: selection.field, value: null };
    });

    update(selections);
    let months;
    let monthIndex;
    for (let i = 0; i < this.props.elements.length; i++) {
      if (selections[i].field == "month_code")
        monthIndex = selections[i].value;
      if (this.props.elements[i].label == "Month") {
        months = this.props.elements[i].options;
      }
    }
    if (["ford-us", "ford-lincoln"].includes(groupName) && months[monthIndex].value >= 288) {
      this.setState({ flag: true });
    }
    else {
      this.setState({ flag: false });
    }
  };

  render() {
    const { classes, elements, selections, groupName } = this.props;
    return (
      <Paper elevation={0} className={classes.paper} classes={{ elevation0: classes.boxShadow }}>
        <Grid container spacing={0} alignItems="stretch">

          {elements.map((filter, index) => {
            if (this.state.flag && filter.label == "Subsegment") {
              return null;
            }
            else {
              return (
                <DynamicFilterElement
                  key={filter.label}
                  label={filter.label}
                  options={filter.options}
                  selection={Array.isArray(selections) && selections[index]}
                  element={filter}
                  update={(v, g) => this.update(index, v, g)}
                  groupName={groupName}
                />
              );
            };
          })}
        </Grid>
      </Paper>
    );
  }
}

DynamicFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  scorecard: PropTypes.shape({
    textHeader: PropTypes.array.isRequired,
    textTable: PropTypes.array.isRequired,
    normHeader: PropTypes.array.isRequired,
    normTable: PropTypes.array.isRequired,
    mainHeader: PropTypes.array.isRequired,
    mainTable: PropTypes.array.isRequired
  })
};

export default withStyles(styles)(DynamicFilters);



// WEBPACK FOOTER //
// ./src/app/Auto/components/ScorecardPage/ScorecardFilters/DynamicFilters.js